
const companyRouter = [
    // 公司首页
    {
        path: '/companyHome', 
        name: 'companyHome', 
        meta: { name: '首页'},
        component: () => import('@/views/company/home')
    },
    // 公司产品页
    {
        path: '/companyProduct', 
        name: 'companyProduct', 
        meta: { name: '产品中心'},
        component: () => import('@/views/company/product')
    },
    // 公司图搜搜首页
    {
        path: '/conpanyImgsearchIndex', 
        name: 'conpanyImgsearchIndex', 
        meta: { name: '图搜搜'},
        component: () => import('@/views/company/index')
    },
    // 公司图搜搜列表页
    {
        path: '/companyImgsearchList', 
        name: 'companyImgsearchList', 
        meta: { name: '图搜搜列表'},
        component: () => import('@/views/company/list')
    },
    // 公司联系我们页面
    {
        path: '/companyContact', 
        name: 'companyContact', 
        meta: { name: '公司介绍'},
        component: () => import('@/views/company/contact')
    },
]
export default companyRouter


// WEBPACK FOOTER //
// ./src/router/modules/company.js